import React, { useState } from 'react';
import QRCodeDisplay from './components/QRCodeDisplay';
import ProgressBar from './components/ProgressBar';

const App = () => {
  const cardNr = "V002025612";
  const guid = "OAY";
  const deviceId = "0CD5CE51-653F-4674-BA3E-C4A1F918F824";
  const [timeElapsed, setTimeElapsed] = useState(0); // État partagé pour le temps écoulé

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <title>QR Hacked</title>
      <h1>Hacked QR</h1>
      <QRCodeDisplay cardNr={cardNr} guid={guid} deviceId={deviceId} timeElapsed={timeElapsed} setTimeElapsed={setTimeElapsed} />
      <div style={{ marginTop: '20px', width: '300px', margin: '0 auto' }}>
        <ProgressBar timeElapsed={timeElapsed} />
      </div>
    </div>
  );
};

export default App;